import styled from 'styled-components';

export const MachinePositionHistoryMapWrapper = styled.div`
  height: 45vh;
`;
